import './news-card.scss';
